import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from "@devhop/ui";
import { useState } from "react";
import type { CartItem } from "../context/CartContext";

type SplitItemDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: CartItem | null;
  onConfirm: (splitQuantity: number) => void;
};

export function SplitItemDialog({
  open,
  onOpenChange,
  item,
  onConfirm,
}: SplitItemDialogProps) {
  const [splitQuantity, setSplitQuantity] = useState<string>("1");

  if (!item) {
    return null;
  }

  const maxQuantity = item.quantity - 1;
  const splitQuantityNum = Number.parseInt(splitQuantity, 10) || 0;
  const isValid = splitQuantityNum > 0 && splitQuantityNum < item.quantity;

  const handleConfirm = () => {
    if (isValid) {
      onConfirm(splitQuantityNum);
      setSplitQuantity("1");
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setSplitQuantity("1");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ແບ່ງລາຍການ</DialogTitle>
          <DialogDescription>
            ເລືອກຈຳນວນທີ່ຕ້ອງການແບ່ງອອກຈາກ {item.productName} (ຈຳນວນທັງໝົດ:{" "}
            {item.quantity})
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="splitQuantity">ຈຳນວນທີ່ຕ້ອການແບ່ງ</Label>
            <Input
              id="splitQuantity"
              type="number"
              min="1"
              max={maxQuantity}
              value={splitQuantity}
              onChange={(e) => setSplitQuantity(e.target.value)}
              placeholder={`1 - ${maxQuantity}`}
            />
            <p className="text-muted-foreground text-xs">
              ຈຳນວນຕ້ອງມີຄ່າລະຫວ່າງ 1 ເຖິງ {maxQuantity}
            </p>
          </div>
          {isValid && (
            <div className="rounded-lg bg-muted p-3">
              <p className="text-sm">
                ຈະແບ່ງເປັນ:
                <br />• ລາຍການເກົ່າ: {item.quantity - splitQuantityNum} ອັນ
                <br />• ລາຍການໃໝ່: {splitQuantityNum} ອັນ
              </p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            ຍົກເລີກ
          </Button>
          <Button onClick={handleConfirm} disabled={!isValid}>
            ຢືນຢັນ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
